// extracted by mini-css-extract-plugin
module.exports = {"container":"e_Sr","poster":"e_Tr","player":"e_Ur","play":"e_Vr","playBadge":"e_Wr","playIcon":"e_Xr","loading":"e_Yr","spin":"e_Zr"};